(function () {
  'use strict';

  var ADDING = false;

  function rootEl() {
    return document.querySelector('[data-cart-confirm]');
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function formatMoney(cents, format) {
    var n = Number(cents);
    if (isNaN(n)) return '';
    var formatString = format || '{{amount}} €';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholder);
    var key = match ? match[1] : 'amount';

    function withDelimiters(number, precision, thousands, decimal) {
      var str = (number / 100).toFixed(precision);
      var parts = str.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var rest = parts[1] ? decimal + parts[1] : '';
      return dollars + rest;
    }

    var value;
    switch (key) {
      case 'amount_no_decimals':
        value = withDelimiters(n, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(n, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(n, 0, '.', ',');
        break;
      default:
        value = withDelimiters(n, 2, ',', '.');
    }
    return formatString.replace(placeholder, value);
  }

  function lineUnitCents(item) {
    if (!item) return null;
    if (item.final_price != null && item.final_price !== '') return item.final_price;
    if (item.price != null && item.price !== '') return item.price;
    return null;
  }

  function itemFromAddPayload(payload, variantId) {
    if (!payload) return null;
    if (payload.items && payload.items.length) {
      var match = null;
      payload.items.forEach(function (item) {
        if (String(item.variant_id) === String(variantId) || String(item.id) === String(variantId)) {
          match = item;
        }
      });
      return match || payload.items[0];
    }
    return payload;
  }

  function itemImage(item) {
    if (!item) return '';
    if (item.featured_image) {
      if (typeof item.featured_image === 'string') return item.featured_image;
      if (item.featured_image.url) return item.featured_image.url;
    }
    if (item.image) return item.image;
    return '';
  }

  function recImage(product) {
    if (!product) return '';
    if (typeof product.featured_image === 'string') return product.featured_image;
    if (product.featured_image) {
      if (product.featured_image.url) return product.featured_image.url;
      if (product.featured_image.src) return product.featured_image.src;
    }
    if (product.images && product.images[0]) {
      var first = product.images[0];
      if (typeof first === 'string') return first;
      return first.src || first.url || '';
    }
    var variant = firstAvailableVariant(product);
    if (variant && variant.featured_image) {
      if (typeof variant.featured_image === 'string') return variant.featured_image;
      return variant.featured_image.src || variant.featured_image.url || '';
    }
    return '';
  }

  function firstAvailableVariant(product) {
    if (!product || !product.variants) return null;
    var i;
    for (i = 0; i < product.variants.length; i += 1) {
      if (product.variants[i].available !== false) return product.variants[i];
    }
    return product.variants[0] || null;
  }

  function setBusy(root, busy) {
    ADDING = !!busy;
    var buttons = root.querySelectorAll('button, a.cart-confirm__btn');
    for (var i = 0; i < buttons.length; i += 1) {
      if (buttons[i].hasAttribute('data-cart-confirm-dismiss')) continue;
      if (buttons[i].classList.contains('cart-confirm__close')) continue;
      buttons[i].disabled = !!busy;
    }
  }

  function showError(root, message) {
    var el = root.querySelector('[data-cart-confirm-error]');
    if (!el) return;
    if (!message) {
      el.hidden = true;
      el.textContent = '';
      return;
    }
    el.hidden = false;
    el.textContent = message;
  }

  function updateHeaderCount(root, count) {
    var n = Number(count);
    if (isNaN(n) || n < 0) return;
    var template = root.getAttribute('data-count-template') || '';
    var label = template.split('__N__').join(String(n));
    var labels = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < labels.length; i += 1) {
      labels[i].setAttribute('data-cart-count', String(n));
      labels[i].textContent = label;
    }
    var badges = document.querySelectorAll('[data-cart-badge]');
    for (var j = 0; j < badges.length; j += 1) {
      if (n > 0) badges[j].removeAttribute('hidden');
      else badges[j].setAttribute('hidden', '');
    }
  }

  function refreshCartCount(root, known) {
    if (known != null && known !== '') {
      updateHeaderCount(root, known);
      return Promise.resolve();
    }
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(base + 'cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('cart');
        return response.json();
      })
      .then(function (cart) {
        updateHeaderCount(root, cart.item_count);
      })
      .catch(function () {});
  }

  function closeVariants() {
    var dialog = document.querySelector('[data-hero-product-variants]');
    if (dialog && dialog.open && typeof dialog.close === 'function') dialog.close();
  }

  function setBoxOpen(root, open) {
    var toggle = root.querySelector('[data-cart-confirm-box-toggle]');
    var panel = root.querySelector('[data-cart-confirm-box-panel]');
    if (!toggle || !panel) return;
    toggle.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.classList.toggle('is-open', open);
    if (open) panel.removeAttribute('hidden');
    else if (prefersReducedMotion()) panel.setAttribute('hidden', '');
    else {
      window.setTimeout(function () {
        if (!toggle.classList.contains('is-open')) panel.setAttribute('hidden', '');
      }, 520);
    }
  }

  function fillSpecs(root, productId) {
    var dest = root.querySelector('[data-cart-confirm-specs]');
    if (!dest) return;
    var pdp = document.querySelector('[data-hero-product]');
    var pdpId = pdp && pdp.getAttribute('data-product-id');
    var source = pdp && pdp.querySelector('.hero-product__specs');
    if (source && pdpId && String(pdpId) === String(productId)) {
      dest.innerHTML = source.innerHTML;
      dest.hidden = dest.childElementCount === 0;
      return;
    }
    dest.innerHTML = '';
    dest.hidden = true;
  }

  function boxSource(variantId) {
    if (variantId != null && variantId !== '') {
      var match = document.querySelector(
        '[data-cart-confirm-box-source][data-variant-id="' + String(variantId) + '"]'
      );
      if (match) return match;
    }
    return document.querySelector('[data-cart-confirm-box-source]:not([data-variant-id])');
  }

  function fillBox(root, productId, variantId) {
    var wrap = root.querySelector('[data-cart-confirm-box]');
    var body = root.querySelector('[data-cart-confirm-box-body]');
    if (!wrap || !body) return;
    var pdp = document.querySelector('[data-hero-product]');
    var pdpId = pdp && pdp.getAttribute('data-product-id');
    var source = boxSource(variantId);
    var html = source ? source.innerHTML.trim() : '';
    if (html && pdpId && String(pdpId) === String(productId)) {
      body.innerHTML = html;
      wrap.hidden = false;
      setBoxOpen(root, false);
      return;
    }
    body.innerHTML = '';
    wrap.hidden = true;
    setBoxOpen(root, false);
  }

  function fillLine(root, item, productId) {
    var name = root.querySelector('[data-cart-confirm-name]');
    var price = root.querySelector('[data-cart-confirm-price]');
    var image = root.querySelector('[data-cart-confirm-image]');
    var qty = root.querySelector('[data-cart-confirm-qty-value]');
    var title = item.product_title || item.title || '';
    var imageUrl = itemImage(item);
    var unit = lineUnitCents(item);
    if (name) name.textContent = title;
    if (price) {
      price.textContent = unit == null ? '' : formatMoney(unit, root.getAttribute('data-money-format'));
    }
    if (image) {
      image.alt = title;
      image.src = imageUrl || image.getAttribute('data-fallback') || image.src;
    }
    if (qty) qty.textContent = String(item.quantity || 1);
    root._cartLineKey = item.key || '';
    root._cartLineQty = Number(item.quantity) || 1;
    root._cartProductId = productId || item.product_id || '';
    fillSpecs(root, root._cartProductId);
    fillBox(root, root._cartProductId, item.variant_id);
  }

  function recTemplate() {
    return document.querySelector('[data-cart-confirm-rec-template]');
  }

  function fallbackRecs(productId) {
    var el = document.querySelector('[data-cart-confirm-fallback-recs]');
    if (!el) return [];
    try {
      var products = JSON.parse(el.textContent);
      if (!Array.isArray(products)) return [];
      return products.filter(function (product) {
        return product && String(product.id) !== String(productId);
      });
    } catch (err) {
      return [];
    }
  }

  function mergeRecs(primary, fallback, productId, limit) {
    var cap = limit || 4;
    var seen = {};
    var out = [];

    function add(product) {
      if (!product || out.length >= cap) return;
      var id = String(product.id || '');
      if (!id || id === String(productId) || seen[id]) return;
      if (!firstAvailableVariant(product)) return;
      seen[id] = true;
      out.push(product);
    }

    (primary || []).forEach(add);
    (fallback || []).forEach(add);
    return out;
  }

  function renderRecs(root, products) {
    var wrap = root.querySelector('[data-cart-confirm-recs]');
    var track = root.querySelector('[data-cart-confirm-recs-track]');
    var template = recTemplate();
    if (!wrap || !track || !template) return;
    track.innerHTML = '';
    if (!products || !products.length) {
      wrap.hidden = true;
      return;
    }
    products.forEach(function (product) {
      var variant = firstAvailableVariant(product);
      if (!variant) return;
      var node = template.content.firstElementChild.cloneNode(true);
      var link = node.querySelector('[data-cart-confirm-rec-link]');
      var img = node.querySelector('[data-cart-confirm-rec-image]');
      var title = node.querySelector('[data-cart-confirm-rec-title]');
      var price = node.querySelector('[data-cart-confirm-rec-price]');
      var add = node.querySelector('[data-cart-confirm-rec-add]');
      var href = product.url || '#';
      var imageUrl = recImage(product);
      if (link) link.setAttribute('href', href);
      if (img) {
        img.alt = product.title || '';
        if (imageUrl) {
          img.src = imageUrl;
          img.hidden = false;
        } else {
          img.removeAttribute('src');
          img.hidden = true;
        }
      }
      if (title) title.textContent = product.title || '';
      if (price) price.textContent = formatMoney(variant.price, root.getAttribute('data-money-format'));
      if (add) {
        add.setAttribute('data-variant-id', String(variant.id));
        add.setAttribute('data-product-id', String(product.id));
        if (variant.available === false) add.disabled = true;
      }
      track.appendChild(node);
    });
    wrap.hidden = track.childElementCount === 0;
    track.scrollLeft = 0;
  }

  function loadRecs(root, productId) {
    var wrap = root.querySelector('[data-cart-confirm-recs]');
    if (!wrap) return;
    var fallback = fallbackRecs(productId);
    var base = root.getAttribute('data-recommendations-url');
    if (!base || !productId) {
      renderRecs(root, mergeRecs([], fallback, productId, 4));
      return;
    }
    var url =
      base +
      (base.indexOf('?') === -1 ? '?' : '&') +
      'product_id=' +
      encodeURIComponent(productId) +
      '&limit=4&intent=related';
    fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('recs');
        return response.json();
      })
      .then(function (data) {
        var products = (data && data.products) || [];
        var filtered = products.filter(function (product) {
          return String(product.id) !== String(productId);
        });
        renderRecs(root, mergeRecs(filtered, fallback, productId, 4));
      })
      .catch(function () {
        renderRecs(root, mergeRecs([], fallback, productId, 4));
      });
  }

  function open(root) {
    if (!root) return;
    closeVariants();
    root.hidden = false;
    root.classList.add('is-open');
    document.body.classList.add('is-cart-confirm-open');
    var closeBtn = root.querySelector('.cart-confirm__close');
    if (closeBtn) closeBtn.focus();
  }

  function close(root) {
    if (!root) return;
    root.classList.remove('is-open');
    root.hidden = true;
    document.body.classList.remove('is-cart-confirm-open');
    showError(root, '');
    setBoxOpen(root, false);
    ADDING = false;
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          var err = new Error((data && (data.description || data.message)) || 'Error');
          err.payload = data;
          throw err;
        }
        return data;
      });
    });
  }

  function addVariant(root, variantId, form) {
    if (!root || !variantId || ADDING) return Promise.resolve();
    var addUrl = root.getAttribute('data-add-url');
    if (!addUrl) return Promise.resolve();
    setBusy(root, true);
    showError(root, '');
    return postJson(addUrl, { items: [{ id: Number(variantId), quantity: 1 }] })
      .then(function (payload) {
        var item = itemFromAddPayload(payload, variantId);
        return refreshCartCount(root, payload.item_count).then(function () {
          if (item) {
            fillLine(root, item, item.product_id);
            loadRecs(root, item.product_id);
          }
          open(root);
        });
      })
      .catch(function (error) {
        showError(root, error.message || root.getAttribute('data-add-error') || '');
        if (!root.classList.contains('is-open') && form) {
          form._cartConfirmNative = true;
          if (typeof form.submit === 'function') form.submit();
        }
      })
      .then(function () {
        setBusy(root, false);
      });
  }

  function changeQty(root, nextQty) {
    if (!root || !root._cartLineKey || ADDING) return;
    var changeUrl = root.getAttribute('data-change-url');
    if (!changeUrl) return;
    var qty = Number(nextQty);
    if (isNaN(qty) || qty < 0) return;
    setBusy(root, true);
    showError(root, '');
    postJson(changeUrl, { id: root._cartLineKey, quantity: qty })
      .then(function (cart) {
        updateHeaderCount(root, cart.item_count);
        if (qty === 0) {
          close(root);
          return;
        }
        var item = null;
        (cart.items || []).forEach(function (line) {
          if (line.key === root._cartLineKey) item = line;
        });
        if (item) fillLine(root, item, item.product_id || root._cartProductId);
      })
      .catch(function (error) {
        showError(root, error.message || '');
      })
      .then(function () {
        setBusy(root, false);
      });
  }

  function variantIdFromForm(form) {
    var checked = form.querySelector('[name="id"]:checked');
    if (checked) return checked.value;
    var hidden = form.querySelector('[name="id"]');
    return hidden ? hidden.value : '';
  }

  function bindRecsDrag(track) {
    if (!track || track._cartConfirmDragBound) return;
    track._cartConfirmDragBound = true;

    var DRAG_THRESHOLD = 6;
    var pointerId = null;
    var startX = 0;
    var startScrollLeft = 0;
    var dragged = false;

    function onPointerMove(event) {
      if (pointerId === null || event.pointerId !== pointerId) return;
      var delta = event.clientX - startX;
      if (!dragged && Math.abs(delta) > DRAG_THRESHOLD) {
        dragged = true;
        track.classList.add('is-dragging');
      }
      if (dragged) track.scrollLeft = startScrollLeft - delta;
    }

    function endDrag(event) {
      if (pointerId === null || event.pointerId !== pointerId) return;
      if (track.hasPointerCapture(pointerId)) track.releasePointerCapture(pointerId);
      pointerId = null;
      track.classList.remove('is-dragging');
      if (dragged && typeof track.scrollTo === 'function') {
        track.scrollTo({
          left: track.scrollLeft + 1,
          behavior: prefersReducedMotion() ? 'auto' : 'smooth'
        });
      }
      track.removeEventListener('pointermove', onPointerMove);
      track.removeEventListener('pointerup', endDrag);
      track.removeEventListener('pointercancel', endDrag);
    }

    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = track.scrollLeft;
      dragged = false;
      track.setPointerCapture(pointerId);
      track.addEventListener('pointermove', onPointerMove);
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
    });

    track.addEventListener(
      'click',
      function (event) {
        if (!dragged) return;
        event.preventDefault();
        event.stopPropagation();
        dragged = false;
      },
      true
    );

    track.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });
  }

  function bind(root) {
    if (!root || root._cartConfirmBound) return;
    root._cartConfirmBound = true;
    bindRecsDrag(root.querySelector('[data-cart-confirm-recs-track]'));

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches) return;
      if (form._cartConfirmNative) return;
      var isConfirmForm =
        form.matches('[data-cart-confirm-add]') ||
        form.matches('.hero-product__form, .hero-product__variants-form');
      if (!isConfirmForm) return;
      var variantId = variantIdFromForm(form);
      if (!variantId) return;
      event.preventDefault();
      addVariant(root, variantId, form);
    });

    root.addEventListener('click', function (event) {
      var dismiss = event.target.closest('[data-cart-confirm-dismiss]');
      if (dismiss && root.contains(dismiss)) {
        event.preventDefault();
        close(root);
        return;
      }

      var qtyBtn = event.target.closest('[data-cart-confirm-qty]');
      if (qtyBtn && root.contains(qtyBtn)) {
        event.preventDefault();
        var step = parseInt(qtyBtn.getAttribute('data-cart-confirm-qty'), 10);
        var next = (root._cartLineQty || 1) + step;
        if (next < 0) return;
        changeQty(root, next);
        return;
      }

      var remove = event.target.closest('[data-cart-confirm-remove]');
      if (remove && root.contains(remove)) {
        event.preventDefault();
        changeQty(root, 0);
        return;
      }

      var toggle = event.target.closest('[data-cart-confirm-box-toggle]');
      if (toggle && root.contains(toggle)) {
        event.preventDefault();
        setBoxOpen(root, !toggle.classList.contains('is-open'));
        return;
      }

      var recAdd = event.target.closest('[data-cart-confirm-rec-add]');
      if (recAdd && root.contains(recAdd)) {
        event.preventDefault();
        var recId = recAdd.getAttribute('data-variant-id');
        if (recId) addVariant(root, recId, null);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (root.hidden) return;
      close(root);
    });
  }

  function init() {
    bind(rootEl());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
